import React from 'react'
import { Field } from 'redux-form'
import SVRMAirportDest from '../../views/SVRMAirportDest'
import 'antd/dist/antd.css'

const _ = require('lodash')



export class SVMCITaEp extends React.Component {

    constructor(props) {
        super(props)
        let me = this
        this.svmtaCurryCom = this.svmtaCurryCom.bind(me)
        this.state = {
            filters: {

                all: [], // Contains the full data
                //"startDate": "2024-07-22T23:42:55.795+00:00" ,
                // "endDate": "2024-07-22T25:42:55.795+00:00" ,
                startDate: new Date()
            }
        }


    }

    svmtaCurryCom = (param1, ctxThis) => (o) => {
        console.log("*******svj22****curry** START")
        console.log(param1)

        let {escountryDstMCityOb, member, index} = this.props
        console.log('sv*****Sep2******svmotaEp**8TA Array')
        console.log(index)
        console.log(member)
        console.log(escountryDstMCityOb)
        let escountryDstMCity = 'US'
        let myorg = `DST${index}`
        let myval = 'US'
        if(escountryDstMCityOb && escountryDstMCityOb[myorg]){
            myval = escountryDstMCityOb[myorg]
        }
        if(myval && (myval.length == 2) ){
            escountryDstMCity = myval

        }

        console.log(ctxThis)
        let cidx  = `{param1}2`

        console.log(o)
        const { input: { onChange, value } } = o
        console.log("*******avaug30****reduxonChange, value from RFI**")
        //we donoe need value in begining
        //cb onChange will be called by handleTaDest
        console.log(value)
        console.log("*******avaug30****reduxonChange, value from RFI END**")
        let svfly_esquery_data={
            airlines:[
                {
                    "name" : "Alaska Airlines",
                    "IATA" : "AS"
                },
                {
                    "name" : "Atlantic Southeast Airlines",
                    "IATA" : "EV"
                },
                
            ]
            ,
            amap:{
                "B6":{
                    "name" : "JetBlue Airways",
                    "IATA" : "B6"
                },
                "UA":{
                    "name" : "United Airlines",
                    "IATA" : "UA"
                }
            },
            pmap:{
                "DCA":{
                    "airportid": 3520,
                    "altitude": 15,
                    "city": "Washington",
                    "country": "United States",
                    "datsource": "OurAirports",
                    "name": "Ronald Reagan Washington National Airport",
                    "stationType": null,
                    "svdst": "A",
                    "svtimezone": "-5",
                    "svtzDatabaseTimezone": "America/New_York",
                    "IATA": "DCA",
                    "ICAO": "KDCA",
                    "LAT": 38.8521,
                    "LNG": -77.037697
                }
            },
            esqueryDestMob :{
                "type": "location",
                "subType": "AIRPORT",
                "name": "JOHN F KENNEDY INTL",
                "detailedName": "NEW YORK/NY/US:JOHN F KENNEDY",
                "id": "AJFK",
                
                "timeZoneOffset": "-04:00",
                "iataCode": "JFK",
                "geoCode": {
                  "latitude": 40.63973,
                  "longitude": -73.77861
                },
                "address": {
                  "cityName": "NEW YORK",
                  "cityCode": "NYC",
                  "countryName": "UNITED STATES OF AMERICA",
                  "countryCode": "US",
                  "stateCode": "NY",
                  "regionCode": "NAMER"
                },
                "analytics": {
                  "travelers": {
                    "score": 35
                  }
                }
              },
               esqueryMob :{
                   iataCode: "ORD",
                   address:  { cityName: "CHICAGO", cityCode: "CHI", countryName: "UNITED STATES OF AMERICA" },
                   detailedName: "CHICAGO/IL/US:O HARE INTERNATI",
                   geoCode:  { latitude: 41.97862, longitude: -87.90472 },
    
                },
            escountryOrg:"US",
            escountryDst:"US",
            my_orgqueryText: "xx",
            my_dstqueryText: "yy",
            STARTDATE:"2025-11-25",
            ENDDATE: "2025-11-27",
            DT_FORMAT: "%Y-%m-%d",
            time_zone: "Asia/Kolkata",
    
    
            esqueryChilds:"m0",
            esqueryInfants:"i0",
            esqueryAdults:"t1",
            esqueryCabin:"ECONOMY",
            esqueryTripType:"roundtrip",
            svpageSize:5
    
    
        }
        let vob = value
        let mofval = null,mofval_str  =''
         
        if (value != null) {
            mofval = value
           
            if(_.isString(mofval) ){
                mofval_str = mofval
            }else{
                mofval_str = ''
                console.log('RFI not sending string type')
            }
           


            console.log("*******svj22****mofval_stre**")

            console.log(mofval_str)



            let mom_value = !value ? mofval_str : mofval
        } else {
            mofval = ''
            mofval_str = ''
        }

        let TIME_NO = false


        /*   <SVRAirportDest svfly_esquery_data={svfly_esquery_data} onSearchDesttxtFancy={this.onSearchDesttxtFancy}/>  */
        return (<SVRMAirportDest escountryDstMCity={escountryDstMCity} svoindex={cidx} svfly_esquery_data={svfly_esquery_data}   onSearchDesttxtFancy={onChange}  />)


    }
    render() {
        console.log('render SVMCITaEp date add')

        let me = this
        let { member } = this.props

        let param1 = "ORD"


        return (

            <Field 
            
            name={`${member}.my_dstqueryText`}
            type="text"
                className="form-control"
                component={this.svmtaCurryCom(param1, this)}
            />
        )


    }

}